import { marketingAutomationStepOperation } from "@redotech/redo-marketing-sdk/schema/automation-step-ops";
import * as z from "zod";

export const updateAutomationSteps = {
  name: "updateAutomationSteps" as const,
  description:
    "Applies step operations (update, insert, remove, move) to one automation and leaves every other step as it is. Use this to change a step instead of rewriting the whole automation. A condition update takes naturalLanguageSummary, a plain-language description of what the new condition matches.",
  mutates: true,
  input: z.object({
    automationId: z.string(),
    operations: z.array(marketingAutomationStepOperation).min(1),
  }),
  output: z.object({ success: z.boolean() }),
};
